<template>
  <div class="pt-4 pb-4 position-relative bg-customize McfCardView">
    <!-- main-info begin -->
    <div class="px-3 mb-4 d-flex align-items-center info">
      <div class="image-panel image-panel-2 rounded-circle">
        <img :src="member.cardPic" :alt="member.currentLevel" />
      </div>
      <div class="mx-3" :style="{ color: member.textColor }">
        <h4 class="mb-1">{{ member.name }}</h4>
        <div class="mb-1 font-size-md" v-if="isMembershipLevelShow">
          <span>{{ member.currentLevel }}</span>
        </div>
        <div class="font-size-md" v-if="isMembershipEndDateShow">
          {{ membershipExpirationDesc }}
        </div>
      </div>
    </div>
    <!-- main-info end -->
    <a v-if="isMobile && isQrcodeButtonShow" class="text-white position-absolute p-3 d-lg-none" @click="openQrcode" style="top:8px; right:0; z-index:20;" href="javascript:void(0)">
      <span class="material-icons-outlined">qr_code</span>
    </a>
    <slot />
    <BackGroundImg
      class="position-absolute"
      v-if="isMobile"
      :headerBackground="backgroundMobilePic"
    />
    <div class="w-100 p-3 mcf-cardview-gradient position-absolute"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import BackGroundImg from '@/components/mcf/BackGroundImg.vue';
import dateTimeFormatter from '@/utils/dateTimeFormatter';
import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  components: {
    BackGroundImg,
  },
  data() {
    return {
      backgroundMobilePic: '',
      isBottomSheetShow: false,
      isQrcodeButtonShow: false,
      isMembershipLevelShow: false,
      isMembershipEndDateShow: false,
      membershipExpirationWording: '',
      member: {
        cardPic: '',
        textColor: '#FFFFFF',
        currentLevel: '',
        name: '',
        typeName: '',
        endTime: 0,
      },
    };
  },
  methods: {
    openQrcode() {
      this.$emit('openQrcode');
    },
    // timestamp to date
    toDate(time) {
      const dateTime = dateTimeFormatter.toDateTime(time);
      return dateTimeFormatter.formatDate(dateTime);
    },
  },
  computed: {
    ...mapState(['isMobile']),
    // 會籍到期日敘述
    membershipExpirationDesc() {
      const vm = this;
      if (
        dateTimeFormatter.toDateTime(vm.member.endTime).getFullYear() < 2099
      ) {
        return `${vm.membershipExpirationWording}${vm.$t(
          'index.member-type-deadline',
          {
            time: vm.toDate(vm.member.endTime),
          },
        )}`;
      }
      return `${vm.membershipExpirationWording}${vm.$t('index.forever')}`;
    },
  },
  created() {
    const vm = this;
    vm.$store.dispatch('getMemberType').then((memberType) => {
      vm.member.cardPic = memberType.cardPic;
      vm.member.textColor = memberType.color;
      vm.member.currentLevel = memberType.currentLevel;
    });
    vm.$store.dispatch('getMemberData').then((memberData) => {
      vm.member.name = memberData.name;
      vm.member.endTime = memberData.endTime;
    });
    vm.$store
      .dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        vm.backgroundMobilePic = setting.backgroundMobilePic;
        vm.isQrcodeButtonShow = pageSettingGetter.getFunction(
          setting,
          'MemberShipCard',
        ).isShow;
        vm.isMembershipLevelShow = pageSettingGetter.getFunction(
          setting,
          'MembershipLevel',
        ).isShow;
        vm.isMembershipEndDateShow = pageSettingGetter.getFunction(
          setting,
          'MembershipEndDate',
        ).isShow;
        vm.membershipExpirationWording = pageSettingGetter.getFunctionWording(
          setting,
          'MemberTypeDeadlineWording',
        );
      });
  },
};
</script>

<style>
.McfCardView {
  min-height: 164px;
  min-width: 240px;
}
.McfCardView .info {
  position: relative;
  text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
  z-index: 10;
}
@media (max-width: 767px) {
  .McfCardView {
    height: 64vw;
  }
}
</style>
